import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'ts-utils';
import { CopyContainer } from '../../styles/CopyContainer';
import { Testimonial } from '../../styles/Testimonial';
import { BodySM, Heading3 } from '../../styles/Typography';
import { LayoutActions } from './LayoutActions';
import { LoadingResultsLayoutConfig } from './LoadingResultsLayout';

export type SocialProofLayoutConfig = LoadingResultsLayoutConfig & {
  title?: string;
  body?: string[];
  primaryButtonTitle: string;
  textAnimationEnabled?: boolean;
};

type SocialProofLayoutProps = SocialProofLayoutConfig & {
  onPressPrimaryButton?: () => void;
};

export const SocialProofLayout: FunctionComponent<SocialProofLayoutProps> = (props) => {
  const { textAnimationEnabled = false } = props;

  return (
    <div data-test="socialProof">
      <StyledCopyContainer>
        {!isEmpty(props?.title) && (
          <StyledHeading
            hasBody={props?.body?.[0] !== undefined}
            animationEnabled={textAnimationEnabled}
            animationIndex={0}
          >
            {props.title}
          </StyledHeading>
        )}
        {props?.body?.map((text: string, index: number) => {
          const animIndex = !isEmpty(props?.title) ? index + 1 : index;
          return (
            <BodySM
              key={index}
              style={{ textAlign: 'left' }}
              data-test="surveyQuestion"
              animationEnabled={textAnimationEnabled}
              animationIndex={animIndex}
            >
              {text}
            </BodySM>
          );
        })}
      </StyledCopyContainer>
      <Testimonial {...props.reviewer} stars={5} />
      <LayoutActions
        primaryButtonTitle={props.primaryButtonTitle}
        onPressPrimaryButton={props.onPressPrimaryButton}
      />
    </div>
  );
};

const StyledCopyContainer = styled(CopyContainer)`
  margin: 0 0 2rem;
`;

const StyledHeading = styled(Heading3)<{ hasBody: boolean }>`
  text-align: left;
  margin-bottom: ${({ hasBody }) => (hasBody ? '0.8em' : '0.2em')};
`;
